import React, { Fragment } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

const ReactTableActions = ({ data, modalShowPDF, modalState }) => {
  const [openModal, setOpenModal] = useState(false);


  return (<Fragment>
    <td role="cell">
      <div style={{ display: 'flex' }}>
        <div style={{ marginLeft: 10 }}>

          <IconButton component="span"
            onClick={(e) => {
              setOpenModal(true)
            }}>
             <FontAwesomeIcon icon={faEye} style={{ margin: '0px 5px 0px 5px', width: 20 }} />
          </IconButton>


        </div>
        {openModal ?
          <div>
            <Modal
              open={openModal}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              style={{ zIndex: 1000 }}
            >
              <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                <IconButton style={{ float: 'right' }} onClick={() => {
                  setOpenModal(false)
                }}>
                  <CloseIcon />
                </IconButton>

                <iframe title="pdf" id="pdfV" width="1000" height="700" src={process.env.REACT_APP_PUBLIC_URL + data.data.original.ruta + sessionStorage.getItem('token')} >
                </iframe>
              </div>
            </Modal>
          </div>
          : null}
      </div>
    </td>
  </Fragment>)
}

export default ReactTableActions; 